import React, { useEffect, useRef, useState, useSyncExternalStore } from "react";
import {
  getGlobalLoadingSnapshot,
  subscribeGlobalLoading,
} from "../utils/globalLoading";
import "./GlobalLoadingBar.css";

const SHOW_DELAY_MS = 200;
const MIN_VISIBLE_MS = 300;

const GlobalLoadingBar = () => {
  const activeRequestCount = useSyncExternalStore(
    subscribeGlobalLoading,
    getGlobalLoadingSnapshot,
    () => 0
  );
  const isActive = activeRequestCount > 0;
  const [isVisible, setIsVisible] = useState(false);
  const isActiveRef = useRef(isActive);
  const isVisibleRef = useRef(false);
  const visibleSinceRef = useRef(0);
  const showTimerRef = useRef(null);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    isActiveRef.current = isActive;

    if (showTimerRef.current !== null) {
      window.clearTimeout(showTimerRef.current);
      showTimerRef.current = null;
    }
    if (hideTimerRef.current !== null) {
      window.clearTimeout(hideTimerRef.current);
      hideTimerRef.current = null;
    }

    if (isActive) {
      if (isVisibleRef.current) return undefined;

      showTimerRef.current = window.setTimeout(() => {
        showTimerRef.current = null;
        if (!isActiveRef.current) return;

        isVisibleRef.current = true;
        visibleSinceRef.current = Date.now();
        setIsVisible(true);
      }, SHOW_DELAY_MS);

      return undefined;
    }

    if (!isVisibleRef.current) return undefined;

    const elapsed = Date.now() - visibleSinceRef.current;
    const remaining = Math.max(0, MIN_VISIBLE_MS - elapsed);

    hideTimerRef.current = window.setTimeout(() => {
      hideTimerRef.current = null;
      isVisibleRef.current = false;
      setIsVisible(false);
    }, remaining);

    return undefined;
  }, [isActive]);

  useEffect(
    () => () => {
      if (showTimerRef.current !== null) {
        window.clearTimeout(showTimerRef.current);
      }
      if (hideTimerRef.current !== null) {
        window.clearTimeout(hideTimerRef.current);
      }
    },
    []
  );

  return (
    <div
      className={`global-loading-bar${isVisible ? " global-loading-bar--visible" : ""}`}
      role={isVisible ? "progressbar" : undefined}
      aria-label={isVisible ? "Chargement en cours" : undefined}
      aria-hidden={!isVisible}
    >
      <div className="global-loading-bar__indicator" />
    </div>
  );
};

export default GlobalLoadingBar;
